import { render, staticRenderFns } from "./course_detail2.vue?vue&type=template&id=6ae3d007&scoped=true&"
import script from "./course_detail2.vue?vue&type=script&lang=js&"
export * from "./course_detail2.vue?vue&type=script&lang=js&"
import style0 from "./course_detail2.vue?vue&type=style&index=0&id=6ae3d007&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae3d007",
  null
  
)

export default component.exports